module.exports = __webpack_public_path__ + "static/sc-04-35b3f5d5e75fa71cc740f5d555c26121.png";